<strong><ng-content></ng-content></strong>
